import React, { FunctionComponent } from 'react';
import { startCase } from 'lodash';
import { InventoryType } from '@upstart/harmony/lib/constants';
import { DealerLaunchStepProps } from '../types';
import { StepInfoGateProps } from './DealerLaunchInfoGate';
import { Dealer } from '../../../types/dealerTypes';
import { Select } from '../../Input/Select/Select';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { INVENTORY_TYPE_NAME } from '../../../utils/constants';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import { TextField } from '../../Input/TextField/TextField';
import styles from '../styles.module.scss';

export const DealerLaunchIntegrationInventoryInfoGate: StepInfoGateProps = {
  title: "Let's have a look at your inventory",
  cardTitle: 'A quick note before we dive into inventory',
  cardDescription:
    "We'll need your permission to get your inventory imported so that every customer gets the most up to date view of your stock at every moment. To do this right, we'll send an email to your provider with your permission to access this information. We'll make sure to 'cc' you on any conversations.",
  continueText: 'I Understand',
};

export const DealerLaunchIntegrationInventory: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });
  const inventoryType = form.watch('launchpad.inventory.provider');

  return (
    <DealerLaunchFormCardLayout
      form={form}
      title={DealerLaunchIntegrationInventoryInfoGate.title}
      subTitle="We want to show your most up to date inventory on the Upstart Auto Retail solution. To do this, we will send an email to your inventory feed provider and 'cc' you on all communications."
      cardTitle="Which inventory management provider do you use?"
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <div className={styles.stepRow}>
        <Select
          label="Inventory Provider"
          tooltip="Pick the inventory feed provider where you price all vehicles."
          name="launchpad.inventory.provider"
          width="md"
          form={form}
          validation={{ required: true }}
          options={Object.values(InventoryType).map((type) => ({
            label: INVENTORY_TYPE_NAME[type] || startCase(type),
            value: type,
          }))}
          addEmptyOption
        />

        {inventoryType === InventoryType.OTHER && (
          <TextField
            label="Other Inventory Provider's Name"
            name="launchpad.inventory.otherProviderName"
            width="md"
            form={form}
            validation={{ required: true }}
          />
        )}
      </div>
    </DealerLaunchFormCardLayout>
  );
};
